export enum MenuIcon {
  dashboard = 'dashboard',
  indicators = 'indicators',
  reports = 'reports',
  summary = 'summary',
  machinesSummary = 'machinesSummary',
}
